export type ProtrusionFormula = 'AVORTED' | 'SANK' | 'NONE' | 'DEFAULT' | 'FIRST' | 'TRANSFER' | 'EMPTY'

const protrusionFormulas: { key: ProtrusionFormula }[] = [
  { key: 'DEFAULT' },
  { key: 'FIRST' },
  { key: 'AVORTED' },
  { key: 'SANK' },
  { key: 'EMPTY' },
  { key: 'NONE' },
]

export default protrusionFormulas
